<div class="vk-web-filter-card" data-testid="filters">
  @if (!isLoaded) {
    <div class="tw-text-center tw-p-5">
      <i class="bwi bwi-spinner bwi-spin" aria-hidden="true"></i>
    </div>
  } @else {
    <div>
      <div class="tw-sr-only" data-testid="filters-header">
        {{ "filters" | i18n }}
      </div>
      <div class="tw-p-4" data-testid="filters-body">
        <div class="tw-mb-3.5">
          <bit-search
            id="search"
            placeholder="{{ searchPlaceholder | i18n }}"
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchTextChanged($event)"
            autocomplete="off"
            appAutofocus
          />
        </div>
        @for (f of filtersList; track f) {
          <div class="filter">
            <app-filter-section
              [activeFilter]="activeFilter"
              [section]="f"
              [isCollectionFilter]="f === filters?.collectionFilter"
            >
            </app-filter-section>
          </div>
        }
      </div>
    </div>
  }
</div>
